import React from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import AliceCarousel from "react-alice-carousel";
import "./style.css";
const responsive = {
  0: { items: 1 },
  568: { items: 2 },
  1024: { items: 4 },
  1200: { items: 5 },
};

const SliderHeader = ({ items }) => {
  const getItem = () => {
    return items.length > 0
      ? items.map((element, index) => (
          <div className="col f-15 brand-Primary-2 f-medium text-nowrap divider-right">
            <label className="f-12 text-defused d-block l-1">
              {element.type}
            </label>
            {element.title}
          </div>
        ))
      : [];
  };

  return (
    <AliceCarousel
      mouseTracking
      items={getItem()}
      responsive={responsive}
      disableSlideInfo={true}
      disableButtonsControls={false}
      disableDotsControls={true}
      controlsStrategy="alternate"
    />
  );
};

export default SliderHeader;
